import PropTypes from "prop-types";
// material
import { Paper, Typography } from "@mui/material";
import Image from "./Image";

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  searchWord: PropTypes.string,
  isSorting: PropTypes.bool,
  image: PropTypes.string,
  subtext: PropTypes.string,
};

export default function SearchNotFound({
  searchWord = "",
  isSorting,
  image = "",
  subtext = "",
  ...other
}) {
  return (
    <Paper {...other}>
      {image && <Image isCenter src={image} alt={searchWord} />}
      <Typography
        gutterBottom
        align="center"
        variant="subtitle1"
        sx={{ color: "error.main" }}
      >
        {!isSorting ? `No ${searchWord} yet!` : "Not found!"}
      </Typography>
      {!isSorting ? (
        <Typography variant="body2" align="center">
          {subtext || (
            <span>Not to worry. They'll show up when they are available.</span>
          )}
        </Typography>
      ) : (
        <Typography variant="body2" align="center">
          No results found for &nbsp;
          <strong>&quot;your search criteria&quot;</strong>. Try checking for
          typos or using complete words.
        </Typography>
      )}
    </Paper>
  );
}
